import { z } from 'zod';
import { TimestampSchema } from './common';

export const IntegrationKindSchema = z.enum(['bob-payments', 'openai', 'meta-ads']);
export type IntegrationKind = z.infer<typeof IntegrationKindSchema>;

export const IntegrationStatusSchema = z.enum(['connected', 'disconnected', 'error']);
export type IntegrationStatus = z.infer<typeof IntegrationStatusSchema>;

export const BobPaymentsConfigSchema = z.object({
  apiUrl: z.string().url(),
  header: z.string().optional(),
  token: z.string().min(20),
  webhookUrl: z.string().url(),
});
export type BobPaymentsConfig = z.infer<typeof BobPaymentsConfigSchema>;

export const OpenAIModelSchema = z.enum(['gpt-4o-mini', 'gpt-4o', 'gpt-3.5-turbo']);
export type OpenAIModel = z.infer<typeof OpenAIModelSchema>;

export const OpenAIConfigSchema = z.object({
  apiKey: z.string().startsWith('sk-').min(20),
  model: OpenAIModelSchema,
  systemPrompt: z.string().min(10).max(8000),
});
export type OpenAIConfig = z.infer<typeof OpenAIConfigSchema>;

export const MetaAdsConfigSchema = z.object({
  accessToken: z.string().min(20),
  accountId: z.string().min(1),
  pixelId: z.string().optional(),
});
export type MetaAdsConfig = z.infer<typeof MetaAdsConfigSchema>;

export const IntegrationSchema = z.object({
  kind: IntegrationKindSchema,
  status: IntegrationStatusSchema,
  lastSyncAt: TimestampSchema.optional(),
  maskedCredentials: z.record(z.string(), z.string()),
  createdAt: TimestampSchema,
  updatedAt: TimestampSchema,
});
export type Integration = z.infer<typeof IntegrationSchema>;

export const IntegrationsListResponseSchema = z.object({
  integrations: z.array(IntegrationSchema),
});
export type IntegrationsListResponse = z.infer<typeof IntegrationsListResponseSchema>;

export const ConnectBobPaymentsInputSchema = BobPaymentsConfigSchema;
export type ConnectBobPaymentsInput = z.infer<typeof ConnectBobPaymentsInputSchema>;

export const ConnectOpenAIInputSchema = OpenAIConfigSchema;
export type ConnectOpenAIInput = z.infer<typeof ConnectOpenAIInputSchema>;

export const ConnectMetaAdsInputSchema = MetaAdsConfigSchema;
export type ConnectMetaAdsInput = z.infer<typeof ConnectMetaAdsInputSchema>;

export const IntegrationTestResultSchema = z.object({
  ok: z.boolean(),
  message: z.string(),
});
export type IntegrationTestResult = z.infer<typeof IntegrationTestResultSchema>;
